let nav = {

    Init : () => {
        nav.View();
        nav.NavActions();
    },

    NavActions : () => {
        Jd.off('click', '.nav-actions').on('click', '.nav-actions', function(event){
            event.preventDefault();

            if (J('body').hasClass('nav-closed')) {

                J('body').removeClass('nav-closed');

                let data = {
                    'user_params' : 'nav_is_open',
                    'value' : '1'
                }
                nav.AjaxUserNavParams(data, function(result){
                });

            } else {
                J('body').addClass('nav-closed');

                let data = {
                    'user_params' : 'nav_is_open',
                    'value' : '0'
                }
                nav.AjaxUserNavParams(data, function(result){
                });
            }
            return;
        });

        Jd.off('click', '.js-mobile-menu').on('click', '.js-mobile-menu', function(event){
            if (J('.nav').is(':visible')) {
                J('.nav').hide();
            } else {
                J('.nav').show();
            }
        });
    },

    AjaxUserNavParams : (data, callback) => {

        let Ajax = J.ajax({
            url : '/admin/users/params/update',
            method: 'POST',
            data: data,
            dataType: 'JSON'
        });

        Ajax.done(function(result){
            return callback(result);
        });

        Ajax.fail(function(error){
            return callback(error);
        });
    },

    View : () => {

        let pathname = window.location.pathname;
        
        J('.nav > ul > li > a').each(function(index, item){

            let href = J(item).attr('href');
            if (pathname != '/admin/') {
                href = href.replace('/admin/','');
            }

            if (href.length > 1 && pathname.indexOf(href) != -1) {
                J(item).parent().addClass('nav-current');
            }
        });
    }
}
module.exports = nav;